import ProfileEmptyState from "@apps/profile/profile-empty-state";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";

const ProfileCoachingInsightsEmptyState = () => (
  <div className="flex flex-col gap-0 bg-white border border-gray-200 rounded-lg px-3 py-4 text-sm">
    <div className="flex items-center justify-between px-3 py-2 rounded-[6px]">
      <span className="tf-header-base-dark">Manager Coaching Insights</span>
      <div className="flex items-center gap-1.5 text-gray-500">
        <TopicflowIcon type="eyeOff" className="w-4 h-4" />
        <span className="text-xs">Only visible to you</span>
      </div>
    </div>
    <div className="p-2">
      <ProfileEmptyState>No coaching insights.</ProfileEmptyState>
    </div>
  </div>
);

export default ProfileCoachingInsightsEmptyState;
